module.exports = __webpack_public_path__ + "static/media/Akemi_3520.979391cd.jpg";